import { useQuery } from '@tanstack/react-query';
import { streamConfig } from '@/feature/dataStream/streamConfig';
import { getCacheTime } from '@/feature/query/time';
import useAuth from '../auth/useAuth';
import { fetchLocalizationSettings } from './api';

export const localizationSettingsQueryKey = ['localizationSettings'];

export const useLocalizationSettingsQuery = () => {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: localizationSettingsQueryKey,
    queryFn: async () => {
      const response = await fetchLocalizationSettings();
      streamConfig.setMeasurementSystem(response.measurementSystem);
      return response;
    },
    initialData: null,
    enabled: isAuthenticated,
    ...getCacheTime('long'),
  });
};
